/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface DeviceOrgTreeDto
 */
export interface DeviceOrgTreeDto {
  /**
   * @type {string}
   * @memberof DeviceOrgTreeDto
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id: string;

  /**
   * Device serial number
   *
   * @type {string}
   * @memberof DeviceOrgTreeDto
   * @example SNR-001
   */
  serial: string;

  /**
   * @type {string}
   * @memberof DeviceOrgTreeDto
   * @example ATLAS
   */
  model: DeviceOrgTreeDtoModelEnum;

  /**
   * Current state of the device
   *
   * @type {string}
   * @memberof DeviceOrgTreeDto
   * @example ONLINE
   */
  state: string;
}

/**
 * @export
 * @enum {string}
 */
export enum DeviceOrgTreeDtoModelEnum {
  ATLAS = 'ATLAS',
  EXPLORER = 'EXPLORER',
}
